export enum RetentionType {
    ItemLevel = 0,
    SnapshotBased = 1
}
